<template>
  <div>
    <div class="d-flex flex-row flex-wrap justify-content-start mx-3 py-4">
      <div class="w-25 text-left">
        <el-date-picker type="daterange" v-model="selects.date" placeholder="Select Date Picker" range-separator="To"
          start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-9">
          <div class="row">
            <div class="col-lg-12">
              <card style="
                  box-shadow: none;
                  padding: 30px 0px 30px 30px;
                  height: 400px;
                  background-color: white;
                margin-bottom: 15px;
                ">
                <p style="color: #000; font-size: 24px; font-weight: 600">
                  Waste Disposed
                </p>
                <div class="chart-area">
                  <line-chart v-if="wastecollected.loaded" :chart-data="wastecollected.chartData"
                    :extra-options="wastecollected.extraOptions" :height="280"></line-chart>
                  <div class="d-flex justify-content-center spinner" v-if="!totalassetChart.loaded">
                    <circle-8></circle-8>
                  </div>
                </div>
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <card style="
                  box-shadow: none;
                  padding: 50px 30px 30px 30px;
                  height: 400px;
                  background-color: white;
                ">
                <div class="row">
                  <div class="col-lg"></div>
                  <div class="col-lg-4">
                    <div class="chart-area position-relative text-center">
                      <div class="pie-chart-container">
                        <pie-chart v-if="statusRatio.loaded" :chart-data="statusRatio.chartData"
                          :extra-options="statusRatio.extraOptions" :height="250"></pie-chart>
                        <p style="
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            margin: 0;
                            color: #000;
                            font-size: 20px;
                            font-weight: 600;
                          ">
                          Annex Collected
                        </p>
                      </div>
                      <div class="d-flex justify-content-center spinner" v-if="!statusRatio.loaded">
                        <circle-8></circle-8>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4" style="margin-top: 50px">
                    <div v-for="(item, index) in vessellegend" :key="index" class="legend-item">
                      <span :style="{ backgroundColor: item.value }" class="legend-circle"></span>
                      <div>
                        <span class="label">{{ item.label }}</span>
                        <!-- <p class="label2">{{ item.label2 }}</p> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg"></div>
                </div>
              </card>
            </div>
          </div>
        </div>
        <div class="col-lg-3 d-flex">
          <card style="
              margin-left: -15px;
              box-shadow: none;
              padding-top: 30px;
              /* height: 830px; */
              background-color: white;
            ">
            <p style="
                color: #000;
                text-align: center;
                font-size: 20px;
                font-weight: 600;
                padding-bottom: 30px;
              ">
              Top Annex Disposed
            </p>
            <div style="height: 580px" class="col-lg-12">
              <div style="padding: 4%" v-for="(file, index) in swdisposed" :key="index" class="row">
                <div class="col-lg-1">
                  <div class="circle">
                    <span class="number">{{ file.value }}</span>
                  </div>
                </div>
                <div style="color: #A5A5A5" class="col-lg text-center">
                  {{ file.label1 }}
                </div>
                <div style="font-weight: 600; color: #3495c6" class="col-lg-5 text-center">
                  {{ file.label2 }} MT
                </div>
              </div>
            </div>
            <div style="
                margin-top: 10%;
                width: 108%;
                margin-left: -4%;
                border-top: 1px solid lightgray;
              "></div>
            <div class="row">
              <div style="
                  margin-left: 10px;
                  color: #A5A5A5;
                  padding: 15px;
                  text-align: right;
                " class="col-lg-10">
                See all Annex Disposed
              </div>
              <div class="col-lg-1">
                <div class="circle" style="
                    cursor: pointer;
                    margin-left: -15px;
                    margin-top: 10px;
                    padding: 18px;
                  " v-on:click="getJobPage()">
                  <span class="number" style="font-size: 30px; font-weight: 500">&gt;</span>
                </div>
              </div>
              <div class="col-lg"></div>
            </div>
          </card>
        </div>
        <!-- </div> -->
        <!-- <div class="row"> -->
      </div>
      <!-- <div class="row">
        <div class="col-lg-9">
          <div class="col-lg-12">
            <card
              style="
                box-shadow: none;
                padding: 30px 0px 30px 30px;
                height: 400px;
                background-color: white;
              "
            >
              <p style="color: #000; font-size: 24px; font-weight: 600">
                Oil Purchased
              </p>
              <div class="chart-area">
                <line-chart
                  v-if="totalassetChart.loaded"
                  :chart-data="totalassetChart.chartData"
                  :extra-options="totalassetChart.extraOptions"
                  :height="280"
                ></line-chart>
                <div
                  class="d-flex justify-content-center spinner"
                  v-if="!totalassetChart.loaded"
                >
                  <circle-8></circle-8>
                </div>
              </div>
            </card>
          </div>
        </div>
        <div class="col-lg-3">
          <card
            style="
              margin-left: -15px;

              box-shadow: none;
              padding-top: 50px;
              height: 400px;
              background-color: white;
            "
          >
            <div class="row">
              <div class="col-lg-7">
                <div class="chart-area position-relative text-center">
                  <div class="pie-chart-container">
                    <pie-chart
                      v-if="oilProduct.loaded"
                      :chart-data="oilProduct.chartData"
                      :extra-options="oilProduct.extraOptions"
                      :height="250"
                    ></pie-chart>
                    <p
                      style="
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        margin: 0;
                        color: #000;
                        font-size: 20px;
                        font-weight: 600;
                      "
                    >
                      Oil Products Purchased
                    </p>
                  </div>
                  <div
                    class="d-flex justify-content-center spinner"
                    v-if="!oilProduct.loaded"
                  >
                    <circle-8></circle-8>
                  </div>
                </div>
              </div>
              <div class="col-lg" style="margin-top: 100px">
                <div
                  v-for="(item, index) in oillegend"
                  :key="index"
                  class="legend-item"
                >
                  <span
                    :style="{ backgroundColor: item.value }"
                    class="legend-circle"
                  ></span>
                  <span class="label">{{ item.label }}</span>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import { Circle8 } from "vue-loading-spinner";
import Card from "../../../components/Cards/Card.vue";
import { Modal, ImageUpload } from "../../../../src/components";
import Ongoing from "../../Dashboard/Admin/InventoryList.vue";

import LineChart from "src/components/Charts/LineChart";
import PieChart from "src/components/Charts/PieChart";
import * as chartConfigs from "@/components/Charts/config";

import config from "@/config";
// Import component
import Loading from "vue-loading-overlay";
import moment from "moment";

export default {
  name: "VesselOverview",

  components: {
    Ongoing,
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    LineChart,
    PieChart,
    Loading,
    Circle8,
  },

  data() {
    return {
      isLoading: true,
      circleNumber: 0,

      selectedFileName: "",
      allfilename: [],
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,

      //data from user
      agencyname: "",
      phoneno: "",
      supportdoc: "",

      fullname: "",
      password: "",
      confirmpassword: "",
      phoneno1: "",
      email: "",
      picdepartment: "",

      fullname2: "",
      password2: "",
      confirmpassword2: "",
      phoneno2: "",
      email2: "",
      picdepartment2: "",

      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      addPIC: false,

      modals: {
        successModal: false,
        failedModal: false,
      },

      selects: {
        date: "",
      },

      swdisposed: [
        // { value: "1", label1: "SW 101", label2: "300,000 MT" },
        // { value: "2", label1: "SW 101", label2: "270,000 MT" },
        // { value: "3", label1: "SW 101", label2: "300,000 MT" },
        // { value: "4", label1: "SW 101", label2: "300,000 MT" },
        // { value: "5", label1: "SW 101", label2: "300,000 MT" },
        // { value: "6", label1: "SW 101", label2: "300,000 MT" },
        // { value: "7", label1: "SW 101", label2: "300,000 MT" },
        // { value: "8", label1: "SW 101", label2: "300,000 MT" },
        // { value: "9", label1: "SW 101", label2: "300,000 MT" },
        // { value: "10", label1: "SW 101", label2: "50,000 MT" },
      ],

      // vessellegend: [
      //   { value: "#3495C6", label: "Scheduled Waste" },
      //   { value: "#33BBB7", label: "Garbage" },
      //   { value: "#33A02C", label: "Sewage" },
      //   { value: "#C1C1C1", label: "Scrap" },
      //   { value: "#EBEBEB", label: "Others" },
      // ],

      vessellegend: [
        // { value: "#3495C6", label: "Annex I", label2: "Oil mixture" },
        // {
        //   value: "#33BBB7",
        //   label: "Annex II",
        //   label2: "Noxious Liquid Substances (NLS)",
        // },
        // { value: "#33A02C", label: "Annex IV", label2: "Sewage" },
        // { value: "#C1C1C1", label: "Annex IV", label2: "Garbage" },
        // {
        //   value: "#EBEBEB",
        //   label: "Annex V",
        //   label2: "Ozone Depleting Substances",
        // },
      ],

      oillegend: [
        { value: "#3495C6", label: "Raw Oil" },
        { value: "#33BBB7", label: "Recon Oil" },
      ],

      // Pie Chart
      statusRatio: {
        chartData: {
          labels: [],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: [
                "#3495C6",
                "#33BBB7",
                "#33A02C",
                "#C1C1C1",
                "#EBEBEB",
              ],
              borderWidth: 0,
              data: [],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.pieChartOptions,
      },

      oilProduct: {
        chartData: {
          labels: ["Raw Oil", "Recon Oil"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#3495C6", "#33BBB7"],
              borderWidth: 0,
              data: [60, 40],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions,
      },

      vesselGenerated: {
        chartData: {
          labels: [
            "Annex I - Oil mixture",
            "Annex II - Noxious Liquid Substances (NLS)",
            "Annex IV - Sewage",
            "Annex V - Garbage",
            "Annex VI - Ozone Depleting Substances",
          ],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: [
                "#3495C6",
                "#33BBB7",
                "#33A02C",
                "#C1C1C1",
                "#EBEBEB",
              ],
              borderWidth: 0,
              data: [35, 20, 5, 30, 10],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions,
      },

      totalassetChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Total Asset",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80],
            },
            {
              label: "Total Asset",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 30, 70, 10, 120, 80],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)",
        ],
        gradientStops: [1, 0.4, 0],
      },
      wastecollected: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Vessel Generated",
              fill: false,
              borderColor: "#32BA7C",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#32BA7C",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#32BA7C",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80],
            },
          ],
        },
        loaded: true,

        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 1, 1],
      },
      xyGraph: {
        label: "xy axis",
        chartData: {
          // labels: ["JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "X Velocity",
              fill: true,
              // backgroundColor: config.colors.purpleGradient,
              borderColor: "#006A51",
              backgroundColor: "rgba(0, 106, 81, 0.5)",
              borderWidth: 1,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 1,
              pointHoverRadius: 1,
              pointHoverBorderWidth: 1,
              pointRadius: 1,
              data: [0, 80, 100, 70, 80, 120, 80],
            },
            {
              label: "Y Velocity",
              fill: true,
              // backgroundColor: config.colors.purpleGradient,
              // borderColor: "#39b097",
              // backgroundColor: "rgba(57, 176, 151, 0.5)",
              borderColor: "#69b7ea",
              backgroundColor: "rgba(105, 183, 234, 0.5)",
              borderWidth: 1,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 1,
              pointHoverRadius: 1,
              pointHoverBorderWidth: 1,
              pointRadius: 1,
              data: [0, 80, 100, 70, 80, 120, 80],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.commonChartOptions,
        gradientColors: config.colors.purpleGradient,
        gradientStops: [1, 0.4, 0],
      },
    };
  },
  methods: {
    ngada(vessellabel, vesseldata, vesselcolor) {
      this.statusRatio = {
        chartData: {
          labels: vessellabel,
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: vesselcolor,
              borderWidth: 0,
              data: vesseldata,
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions,
      };
      console.log(this.statusRatio);
    },
    getData() {
      this.wastecollected.loaded = false;
      this.statusRatio.loaded = false;
      let vessellabel = [];
      let vesseldata = [];
      let vesselcolor = [];

      let start = moment(this.selects.date[0]).format("YYYY-MM-DD");
      let end = moment(this.selects.date[1]).format("YYYY-MM-DD");
      this.$http
        .get(
          ":10001/api/v1/overview/incoming/new?start_date=" +
          start +
          "&end_date=" +
          end +
          "&service_location=" +
          this.selects.port
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            // line chart
            let timestamp = [];

            let vessel = [];

            for (var i = 0; i < response.graph.month.length; i++) {
              timestamp.push(response.graph.month[i].month_name.toUpperCase());
              vessel.push(response.graph.month[i].data.vessel);
            }

            this.wastecollected = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    label: "Vessel Generated",
                    fill: false,
                    borderColor: "#32BA7C",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "#32BA7C",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#32BA7C",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: vessel,
                  },
                ],
              },
              loaded: true,

              extraOptions: chartConfigs.purpleChartOptions,
              gradientColors: config.colors.primaryGradient,
              gradientStops: [1, 1, 1],
            };

            vessellabel = response.vessel_generated_donut_chart.completed.label;

            vesseldata = response.vessel_generated_donut_chart.completed.data;

            vesselcolor = response.vessel_generated_donut_chart.completed.color;

            this.ngada(vessellabel, vesseldata, vesselcolor);

            this.vessellegend = [];
            for (
              var i = 0;
              i < response.vessel_generated_donut_chart.completed.color.length;
              i++
            ) {
              let obj = {
                value: response.vessel_generated_donut_chart.completed.color[i],
                label: response.vessel_generated_donut_chart.completed.label[i],
              };
              this.vessellegend.push(obj);
            }
            console.log(this.vessellegend);

            this.swdisposed = [];
            if (response.annex_weight != null) {
              for (var i = 0; i < response.annex_weight.length; i++) {
                let obj = {
                  label1: response.annex_weight[i].Name,
                  label2: response.annex_weight[i].Count,
                  value: i + 1,
                };

                this.swdisposed.push(obj);
              }
            }
          }
        });
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },

    toggleShow2() {
      this.showPassword2 = !this.showPassword2;
    },
    toggleShow3() {
      this.showPassword3 = !this.showPassword3;
    },

    addCard() {
      this.addPIC = true;
    },
    cancelAddCard() {
      this.addPIC = false;
    },
    successModal() {
      this.modals.successModal = true;
    },
    failedModal() {
      this.modals.failedModal = true;
    },
    closeFailedModal() {
      this.modals.failedModal = false;
    },
    getJobPage() {
      this.$router.push("/Vessel/Request");
    },
    onFileChange(event) {
      const input = event.target;
      if (input.files.length > 0) {
        for (let i = 0; i < input.files.length; i++) {
          this.selectedFileName = input.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
      } else {
        this.selectedFileName = "";
      }
    },
    graph() {
      this.xyzGraph = {
        labels: "xyz axis",
        chartData: {
          // labels: ["JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "X Velocity",
              fill: true,
              // backgroundColor: config.colors.purpleGradient,
              borderColor: "#006A51",
              backgroundColor: "rgba(0, 106, 81, 0.5)",
              borderWidth: 1,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 1,
              pointHoverRadius: 1,
              pointHoverBorderWidth: 1,
              pointRadius: 1,
              data: [0, 80, 100, 70, 80, 120, 80],
            },
            {
              label: "Y Velocity",
              fill: true,
              //backgroundColor: config.colors.purpleGradient,
              // borderColor: "#39b097",
              // backgroundColor: "rgba(57, 176, 151, 0.5)",
              borderColor: "#69b7ea",
              backgroundColor: "rgba(105, 183, 234, 0.5)",
              borderWidth: 1,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 1,
              pointHoverRadius: 1,
              pointHoverBorderWidth: 1,
              pointRadius: 1,
              data: [0, 80, 100, 70, 80, 120, 80],
            },
            {
              label: "Z Velocity",
              fill: true,
              //backgroundColor: config.colors.purpleGradient,
              // borderColor: "#6BE2C9",
              // backgroundColor: "rgba(107, 226, 201, 0.5)",
              borderColor: "#b88de9",
              backgroundColor: "rgba(184, 141, 233, 0.5)",
              borderWidth: 1,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 1,
              pointHoverRadius: 1,
              pointHoverBorderWidth: 1,
              pointRadius: 1,
              data: [0, 80, 100, 70, 80, 120, 80],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.commonChartOptions,
        gradientColors: config.colors.purpleGradient,
        gradientStops: [1, 0.4, 0],
      };
    },
    graph2() {
      this.totalassetChart = {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Total Asset",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80],
            },
            // {
            //   label: "Total Asset",
            //   fill: true,
            //   borderColor: "rgba(94, 10, 30, 1)",
            //   borderWidth: 2,
            //   borderDash: [],
            //   borderDashOffset: 0.0,
            //   pointBackgroundColor: "rgba(94, 170, 30, 1)",
            //   pointBorderColor: "rgba(255,255,255,0)",
            //   pointHoverBackgroundColor: "#be55ed",
            //   pointBorderWidth: 20,
            //   pointHoverRadius: 4,
            //   pointHoverBorderWidth: 15,
            //   pointRadius: 4,
            //   data: [80, 30, 70, 10, 20, 80],
            // },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)",
        ],
        gradientStops: [1, 0.4, 0],
      };
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
  },
  created() {
    this.selects.date = [moment().startOf("y"), moment().endOf("y")];
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  watch: {
    "selects.date"() {
      this.getData();
    },
  },
};
</script>
<style scoped>
.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.legend-circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 8px;
}

.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

p {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}

.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #3495c6;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
}

.number {
  color: white;
}

.pie-chart-container {
  position: relative;
  width: 100%;
  /* Set width as required */
  height: 250px;
  /* Set height as required */
}

.chart-title {
  width: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  /* Other styling properties as needed */
}

.label {
  color: #666;
}

.label2 {
  color: #ccc;
  margin-top: -7px;
  font-size: 12px;
}
</style>
